import { mapState } from "vuex";
import { PAGES, PRODUCTION_ORIGIN } from "@consts";
import { isEmpty } from "@utils";

export default {
	name: "Pagination",
	props: {
		currentPage: {
			type: Number,
			default: 1,
		},
		totalPages: {
			type: Number,
			default: 1,
		},
		relativePagePath: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			currentPageInput: 1,
		};
	},
	computed: {
		...mapState("navigation", ["currentRouteName"]),
		prevLink() {
			if (this.currentPage <= 1) {
				return null;
			}

			return this.getPagePathWithNumber(this.currentPage - 1, true);
		},
		nextLink() {
			if (this.currentPage >= this.totalPages) {
				return null;
			}

			return this.getPagePathWithNumber(this.currentPage + 1, true);
		},
		renderAsLinks() {
			if (
				[PAGES.ARTICLE_INDEX, PAGES.WORDLE_ARTICLES_INDEX].includes(
					this.$route.name
				)
			) {
				return true;
			}

			return false;
		},
	},
	methods: {
		getPagePathWithNumber(
			pageNumber = this.currentPageInput,
			absolute = false
		) {
			const prefix = absolute ? PRODUCTION_ORIGIN : "";

			const suffix =
				typeof pageNumber === "number" && pageNumber > 1
					? `${pageNumber}/`
					: "";

			return `${prefix}${this.relativePagePath}${suffix}`;
		},
		onPrevClick() {
			this.switchPage(this.currentPageInput - 1);
		},
		onNextClick() {
			this.switchPage(this.currentPageInput + 1);
		},
		switchPage(newPageNumber = this.currentPageInput) {
			if (this.isInvalidValue(newPageNumber) || isEmpty(newPageNumber)) {
				return;
			}

			this.currentPageInput = newPageNumber;
			this.$nextTick(() => {
				if (this.renderAsLinks) {
					this.$router.push(
						this.getPagePathWithNumber(this.currentPageInput)
					);
				} else {
					this.$emit("loadWords", { page: this.currentPageInput });
				}

				this.scrollToTop();
				this.removeFocus();
			});
		},
		scrollToTop() {
			window.scrollTo(0, 0);
			window.dispatchEvent(new CustomEvent("scroll"));
		},
		removeFocus() {
			document.activeElement?.blur();
		},
		onEnter() {
			this.switchPage();
		},
		isInvalidValue(value) {
			return value <= 0 || value > this.totalPages;
		},
		onlyNumber(event) {
			if (
				!/\d/.test(event.key) &&
				event.keyCode !== 8 &&
				event.keyCode !== 13
			) {
				return event.preventDefault();
			}
		},
	},
	head() {
		const links = [];
		if (this.renderAsLinks && this.nextLink) {
			links.push({
				rel: "next",
				href: this.nextLink,
				hid: "blog-next",
			});
		}

		if (this.renderAsLinks && this.prevLink) {
			links.push({
				rel: "prev",
				href: this.prevLink,
				hid: "blog-prev",
			});
		}

		return { link: links };
	},
	created() {
		this.currentPageInput = this.currentPage;
	},
	watch: {
		currentPageInput(newValue, oldValue) {
			if (isEmpty(newValue)) {
				this.currentPageInput = "";
				return;
			}

			if (this.isInvalidValue(newValue)) {
				this.currentPageInput = oldValue;
				return;
			}

			this.currentPageInput = parseInt(newValue);
		},
		currentPage(newValue, oldValue) {
			this.currentPageInput = newValue;
		},
	},
};
